var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fab29b;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 239.5,
    cy: 223,
    r: 191
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.3,339.1c-31.8,71.8-103.2,119.7-181.7,121.8h-11.8c-75.3-2.4-144.7-47-178-114.9-34.9-71.1-24.3-159.9,26.2-220.9,50.4-60.8,132.5-87.4,209.1-67.7,6.9,1.8,11.1,8.9,9.3,15.9-.9,3.4-3,6.2-6,8-3,1.8-6.5,2.2-9.9,1.4-66.8-17.3-138.5,5.9-182.7,59.1-44.1,53.2-53.3,130.7-22.9,192.8,30.3,61.9,96.9,102.2,165.8,100.4,68.6-1.8,130.9-43.6,158.7-106.3,16.3-36.8,19.7-78.6,9.7-117.5-1.8-7,2.4-14.1,9.3-15.8h0c3.4-.9,6.9-.4,9.9,1.4,3,1.8,5.1,4.6,6,7.9,11.5,44.5,7.6,92.3-11.1,134.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461,97.9c0,3.5-1.3,6.8-3.8,9.2l-192,192c-4.1,4.1-5,4.1-7,3.9-.6,0-1.3,0-2.2,0-3.5,0-6.7-1.4-9.2-3.8l-67.9-67.9c-5.1-5.1-5.1-13.3,0-18.4s5.7-3.8,9.2-3.8,6.8,1.3,9.2,3.8l58.7,58.7,182.8-182.8c5.1-5.1,13.3-5.1,18.4,0,2.4,2.4,3.8,5.7,3.8,9.2Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Selection.079a6f13f713d84fd74f61bdde02d4ac.svg";